import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';

import app from '../slices/app';
import user from '../slices/user';

import devTool from './devTool';
import emailVerification from './emailVerification';
import env from './env';
import payment from './payment';
import properties from './properties';
import relist from './relist';
import rentGuarantee from './rentGuarantee';

const rootReducer = (...args: Parameters<typeof connectRouter>) =>
  combineReducers({
    app,
    env,
    emailVerification,
    properties,
    payment,
    user,
    relist,
    rentGuarantee,
    router: connectRouter(...args),
    devTool,
  });

export type State = ReturnType<ReturnType<typeof rootReducer>>;

export default rootReducer;
